const LANG = window.__LANGUAGE || 'en';

let STRINGS = [
	// Mark any strings the need to be added to po files
	gettext('Choose file...'),
	gettext('Browse'),
]

let localize = () => {
	if (LANG) {
		jQuery.extend(jQuery.fn.pickadate.defaults, {
			today: gettext('Today'),
			clear: gettext('Clear'),
			close: gettext('Close'),
			firstDay: 1,
			labelMonthNext: gettext('Next month'),
			labelMonthPrev: gettext('Previous month'),
			labelMonthSelect: gettext('Choose month'),
			labelYearSelect: gettext('Choose year')
		});

		if (/fr/.test(LANG)) {
			jQuery.extend(
				jQuery.fn.pickadate.defaults, {
					monthsFull: [ 'janvier', 'février', 'mars', 'avril', 'mai', 'juin', 'juillet', 'aout', 'septembre', 'octobre', 'novembre', 'décembre' ],
					monthsShort: [ 'janv.', 'févr.', 'mars', 'avril', 'mai', 'juin', 'juil.', 'août', 'sept.', 'oct.', 'nov.', 'déc.' ],
					weekdaysFull: [ 'dimanche', 'lundi', 'mardi', 'mercredi', 'jeudi', 'vendredi', 'samedi' ],
					weekdaysShort: [ 'dim', 'lun', 'mar', 'mer', 'jeu', 'ven', 'sam' ],
			});
		}
	}

	$('.custom-file-control').attr('lang', LANG);
}

$(localize);

window.localize = localize;
